// extracted by mini-css-extract-plugin
export default {"paymentSection":"_5-z"};